export default __webpack_public_path__ + "static/media/Major Rune Stone of the Second Wind.fed0c525.jpg";